import "core-js/modules/es6.regexp.to-string";
import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import _typeof from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
export var LocalStorageWorker =
/*#__PURE__*/
function () {
  function LocalStorageWorker() {
    _classCallCheck(this, LocalStorageWorker);

    this.localStorageSupported = this.canWriteStorage();
    this.key = {
      UUID: "uuid"
    };
  }

  _createClass(LocalStorageWorker, [{
    key: "canWriteStorage",
    value: function canWriteStorage() {
      if (!window.localStorage) {
        // console.log("window下不存在localStorage");
        return false;
      }

      try {
        window.localStorage.setItem("@@", "test");
        window.localStorage.removeItem("@@");
        return true;
      } catch (e) {
        // console.log("window不能使用localStorage");
        return false;
      }
    }
  }, {
    key: "dataToString",
    value: function dataToString(data) {
      if (data !== undefined && data != null) {
        var type = _typeof(data);

        if (type === "function") {
          return undefined;
        } else if (type === "object") {
          return _JSON$stringify(data);
        } else {
          return data.toString();
        }
      } else {
        return undefined;
      }
    }
  }, {
    key: "stringToData",
    value: function stringToData(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return str;
      }
    }
  }, {
    key: "set",
    value: function set(key, data) {
      if (this.localStorageSupported) {
        var dataStr = this.dataToString(data);
        localStorage.setItem(key, dataStr);
        return this.get(key);
      } else {
        return null;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      if (this.localStorageSupported) {
        var data = localStorage.getItem(key);
        return this.stringToData(data);
      } else {
        return null;
      }
    }
    /**
     *  判断是否有对应key的本地存储
     * @param key
     */

  }, {
    key: "has",
    value: function has(key) {
      if (this.localStorageSupported) {
        var result = this.get(key);
        return result == null || result === undefined ? false : true;
      } else {
        return false;
      }
    }
    /**
     * 获取所有的Key,转成object返回
     */

  }, {
    key: "getAll",
    value: function getAll() {
      var result = {}; // for (let i = 0; i < localStorage.length; i++) {
      //   result[localStorage.key(i)] = this.get(localStorage.key(i));
      // }

      return result;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (this.localStorageSupported) {
        localStorage.removeItem(key);
      } else {
        return null;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.localStorageSupported) {
        localStorage.clear();
      } else {
        return null;
      }
    }
  }]);

  return LocalStorageWorker;
}();
var localStorageHelper = new LocalStorageWorker();
export default localStorageHelper;